import { useCommentsPreviewMode } from "./use-comments-preview-mode";

interface StoryComments {
  enabled?: boolean;
  mode?: string | null;
}

/** Whether to show standard comment UI (lede count, drawer) for this story. */
export function useShowStoryComments(
  comments: StoryComments | null | undefined,
): boolean {
  const previewMode = useCommentsPreviewMode();
  return (
    previewMode || Boolean(comments?.enabled && comments.mode === "standard")
  );
}
